// Region definitions and project-to-region mapping for a nationwide construction company

export interface Region {
  id: string
  name: string
  shortName: string
}

export interface ProjectRegionMapping {
  projectName: string
  regionId: string
  city: string
  state: string
}

export const REGIONS: Region[] = [
  { id: 'northeast', name: 'Northeast', shortName: 'NE' },
  { id: 'mid_atlantic', name: 'Mid-Atlantic', shortName: 'MA' },
  { id: 'southeast', name: 'Southeast', shortName: 'SE' },
  { id: 'midwest', name: 'Midwest', shortName: 'MW' },
  { id: 'southwest', name: 'Southwest', shortName: 'SW' },
  { id: 'west_coast', name: 'West Coast', shortName: 'WC' },
]

export const PROJECT_REGION_MAP: ProjectRegionMapping[] = [
  // Northeast
  {
    projectName: 'Court Square LIC',
    regionId: 'northeast',
    city: 'Long Island City',
    state: 'NY',
  },
  {
    projectName: 'Hudson Yards Tower C',
    regionId: 'northeast',
    city: 'New York',
    state: 'NY',
  },
  {
    projectName: '99 Claremont Ave',
    regionId: 'northeast',
    city: 'New York',
    state: 'NY',
  },
  {
    projectName: '100 Wall Street',
    regionId: 'northeast',
    city: 'New York',
    state: 'NY',
  },
  {
    projectName: 'Boston Seaport Block L',
    regionId: 'northeast',
    city: 'Boston',
    state: 'MA',
  },
  {
    projectName: 'Kendall Square Lab',
    regionId: 'northeast',
    city: 'Cambridge',
    state: 'MA',
  },
  {
    projectName: 'Fenway Center Phase 2',
    regionId: 'northeast',
    city: 'Boston',
    state: 'MA',
  },
  {
    projectName: 'Providence Innovation Center',
    regionId: 'northeast',
    city: 'Providence',
    state: 'RI',
  },
  {
    projectName: 'Portland Harbor Redevelopment',
    regionId: 'northeast',
    city: 'Portland',
    state: 'ME',
  },
  {
    projectName: 'Stamford Transit Hub',
    regionId: 'northeast',
    city: 'Stamford',
    state: 'CT',
  },
  {
    projectName: 'New Haven BioPark',
    regionId: 'northeast',
    city: 'New Haven',
    state: 'CT',
  },
  {
    projectName: 'Worcester Polar Park Commons',
    regionId: 'northeast',
    city: 'Worcester',
    state: 'MA',
  },
  {
    projectName: 'Manchester Millyard Extension',
    regionId: 'northeast',
    city: 'Manchester',
    state: 'NH',
  },
  {
    projectName: 'Burlington Waterfront',
    regionId: 'northeast',
    city: 'Burlington',
    state: 'VT',
  },
  {
    projectName: 'Somerville Assembly Row',
    regionId: 'northeast',
    city: 'Somerville',
    state: 'MA',
  },
  {
    projectName: 'Queens Plaza South',
    regionId: 'northeast',
    city: 'Queens',
    state: 'NY',
  },
  {
    projectName: 'Brooklyn Point Tower',
    regionId: 'northeast',
    city: 'Brooklyn',
    state: 'NY',
  },
  {
    projectName: 'Jersey City Urby 2',
    regionId: 'northeast',
    city: 'Jersey City',
    state: 'NJ',
  },
  {
    projectName: 'Hoboken Terminal Revitalization',
    regionId: 'northeast',
    city: 'Hoboken',
    state: 'NJ',
  },
  {
    projectName: 'Newark Gateway Center',
    regionId: 'northeast',
    city: 'Newark',
    state: 'NJ',
  },

  // Mid-Atlantic
  {
    projectName: 'Brooklyn Navy Yard',
    regionId: 'mid_atlantic',
    city: 'Brooklyn',
    state: 'NY',
  },
  {
    projectName: 'One Vanderbilt Annex',
    regionId: 'mid_atlantic',
    city: 'New York',
    state: 'NY',
  },
  {
    projectName: 'Penn Station Renovation',
    regionId: 'mid_atlantic',
    city: 'New York',
    state: 'NY',
  },
  {
    projectName: 'Philly Navy Yard Block 12',
    regionId: 'mid_atlantic',
    city: 'Philadelphia',
    state: 'PA',
  },
  {
    projectName: 'Schuylkill Yards Tower',
    regionId: 'mid_atlantic',
    city: 'Philadelphia',
    state: 'PA',
  },
  {
    projectName: 'Baltimore Inner Harbor East',
    regionId: 'mid_atlantic',
    city: 'Baltimore',
    state: 'MD',
  },
  {
    projectName: 'DC Wharf Phase 3',
    regionId: 'mid_atlantic',
    city: 'Washington',
    state: 'DC',
  },
  {
    projectName: 'National Landing HQ2',
    regionId: 'mid_atlantic',
    city: 'Arlington',
    state: 'VA',
  },
  {
    projectName: 'Tysons Corner Block C',
    regionId: 'mid_atlantic',
    city: 'Tysons',
    state: 'VA',
  },
  {
    projectName: 'Bethesda Metro Center',
    regionId: 'mid_atlantic',
    city: 'Bethesda',
    state: 'MD',
  },
  // Southeast
  {
    projectName: 'Midtown Atlanta Tower',
    regionId: 'southeast',
    city: 'Atlanta',
    state: 'GA',
  },
  {
    projectName: 'Charlotte Medical Center',
    regionId: 'southeast',
    city: 'Charlotte',
    state: 'NC',
  },
  {
    projectName: 'Miami Brickell City Centre 2',
    regionId: 'southeast',
    city: 'Miami',
    state: 'FL',
  },
  {
    projectName: 'Tampa Water Street Block 5',
    regionId: 'southeast',
    city: 'Tampa',
    state: 'FL',
  },
  {
    projectName: 'Orlando Creative Village',
    regionId: 'southeast',
    city: 'Orlando',
    state: 'FL',
  },
  {
    projectName: 'Nashville Yards Phase 2',
    regionId: 'southeast',
    city: 'Nashville',
    state: 'TN',
  },
  {
    projectName: 'Raleigh North Hills Expansion',
    regionId: 'southeast',
    city: 'Raleigh',
    state: 'NC',
  },
  {
    projectName: 'Charleston Navy Base',
    regionId: 'southeast',
    city: 'Charleston',
    state: 'SC',
  },
  {
    projectName: 'Greenville Camperdown',
    regionId: 'southeast',
    city: 'Greenville',
    state: 'SC',
  },
  {
    projectName: 'Savannah River Landing',
    regionId: 'southeast',
    city: 'Savannah',
    state: 'GA',
  },
  {
    projectName: 'Jacksonville Sports Complex',
    regionId: 'southeast',
    city: 'Jacksonville',
    state: 'FL',
  },
  {
    projectName: 'Birmingham Uptown',
    regionId: 'southeast',
    city: 'Birmingham',
    state: 'AL',
  },
  // Midwest
  {
    projectName: 'Chicago Union Station',
    regionId: 'midwest',
    city: 'Chicago',
    state: 'IL',
  },
  {
    projectName: 'Detroit Riverwalk',
    regionId: 'midwest',
    city: 'Detroit',
    state: 'MI',
  },
  {
    projectName: 'Minneapolis North Loop Block',
    regionId: 'midwest',
    city: 'Minneapolis',
    state: 'MN',
  },
  {
    projectName: 'St. Louis Cortex Innovation',
    regionId: 'midwest',
    city: 'St. Louis',
    state: 'MO',
  },
  {
    projectName: 'Kansas City Power & Light 2',
    regionId: 'midwest',
    city: 'Kansas City',
    state: 'MO',
  },
  {
    projectName: 'Indianapolis 16 Tech',
    regionId: 'midwest',
    city: 'Indianapolis',
    state: 'IN',
  },
  {
    projectName: 'Lincoln Haymarket Expansion',
    regionId: 'midwest',
    city: 'Lincoln',
    state: 'NE',
  },

  // Southwest
  {
    projectName: 'Austin Tech Campus',
    regionId: 'southwest',
    city: 'Austin',
    state: 'TX',
  },
  {
    projectName: 'Dallas Convention Center',
    regionId: 'southwest',
    city: 'Dallas',
    state: 'TX',
  },
  {
    projectName: 'Houston Innovation District',
    regionId: 'southwest',
    city: 'Houston',
    state: 'TX',
  },
  {
    projectName: 'Phoenix Warehouse District',
    regionId: 'southwest',
    city: 'Phoenix',
    state: 'AZ',
  },
  {
    projectName: 'San Antonio Pearl Brewery 2',
    regionId: 'southwest',
    city: 'San Antonio',
    state: 'TX',
  },
  {
    projectName: 'Fort Worth Panther Island',
    regionId: 'southwest',
    city: 'Fort Worth',
    state: 'TX',
  },
  {
    projectName: 'Tempe Town Lake Block',
    regionId: 'southwest',
    city: 'Tempe',
    state: 'AZ',
  },
  {
    projectName: 'Scottsdale Fashion Square Expansion',
    regionId: 'southwest',
    city: 'Scottsdale',
    state: 'AZ',
  },
  {
    projectName: 'Tucson Downtown Links',
    regionId: 'southwest',
    city: 'Tucson',
    state: 'AZ',
  },
  {
    projectName: 'Albuquerque Innovate ABQ',
    regionId: 'southwest',
    city: 'Albuquerque',
    state: 'NM',
  },
  {
    projectName: 'Santa Fe Railyard',
    regionId: 'southwest',
    city: 'Santa Fe',
    state: 'NM',
  },
  {
    projectName: 'Oklahoma City Core to Shore',
    regionId: 'southwest',
    city: 'Oklahoma City',
    state: 'OK',
  },
  {
    projectName: 'Tulsa Arts District',
    regionId: 'southwest',
    city: 'Tulsa',
    state: 'OK',
  },
  {
    projectName: 'El Paso Downtown Revitalization',
    regionId: 'southwest',
    city: 'El Paso',
    state: 'TX',
  },
  {
    projectName: 'Corpus Christi Harbor Bridge',
    regionId: 'southwest',
    city: 'Corpus Christi',
    state: 'TX',
  },
  {
    projectName: 'Plano Legacy West 2',
    regionId: 'southwest',
    city: 'Plano',
    state: 'TX',
  },
  {
    projectName: 'Frisco Station',
    regionId: 'southwest',
    city: 'Frisco',
    state: 'TX',
  },
  {
    projectName: 'Mesa Riverview Expansion',
    regionId: 'southwest',
    city: 'Mesa',
    state: 'AZ',
  },
  {
    projectName: 'Chandler Price Road Corridor',
    regionId: 'southwest',
    city: 'Chandler',
    state: 'AZ',
  },
  {
    projectName: 'Las Cruces Downtown Plaza',
    regionId: 'southwest',
    city: 'Las Cruces',
    state: 'NM',
  },

  // West Coast
  {
    projectName: 'LA Metro Extension',
    regionId: 'west_coast',
    city: 'Los Angeles',
    state: 'CA',
  },
  {
    projectName: 'San Francisco Bay Tower',
    regionId: 'west_coast',
    city: 'San Francisco',
    state: 'CA',
  },
  {
    projectName: 'Seattle Waterfront Redevelopment',
    regionId: 'west_coast',
    city: 'Seattle',
    state: 'WA',
  },
  {
    projectName: 'Bellevue Spring District',
    regionId: 'west_coast',
    city: 'Bellevue',
    state: 'WA',
  },
  {
    projectName: 'Portland Pearl District Block',
    regionId: 'west_coast',
    city: 'Portland',
    state: 'OR',
  },
  {
    projectName: 'San Diego Research Park',
    regionId: 'west_coast',
    city: 'San Diego',
    state: 'CA',
  },
  {
    projectName: 'San Jose Diridon Station',
    regionId: 'west_coast',
    city: 'San Jose',
    state: 'CA',
  },
  {
    projectName: 'Oakland Brooklyn Basin',
    regionId: 'west_coast',
    city: 'Oakland',
    state: 'CA',
  },
  {
    projectName: 'Sacramento Railyards',
    regionId: 'west_coast',
    city: 'Sacramento',
    state: 'CA',
  },
  {
    projectName: 'Irvine Spectrum Expansion',
    regionId: 'west_coast',
    city: 'Irvine',
    state: 'CA',
  },
]

export function getRegionForProject(projectName: string): Region | undefined {
  const mapping = PROJECT_REGION_MAP.find((m) => m.projectName === projectName)
  if (!mapping) return undefined
  return REGIONS.find((r) => r.id === mapping.regionId)
}

export function getProjectsForRegion(regionId: string): string[] {
  return PROJECT_REGION_MAP.filter((m) => m.regionId === regionId).map(
    (m) => m.projectName,
  )
}

export function getRegionById(regionId: string): Region | undefined {
  return REGIONS.find((r) => r.id === regionId)
}
